import { ButtonLink, getHomeRoute } from '@shared';
import styled from 'styled-components';
import { AuthHeading } from '../components/Heading';
import { IntroMessage } from '../components/IntroMessage';

const EmailSentMessageWrapper = styled.div`
  text-align: center;

  em {
    font-style: normal;
    font-weight: ${(props) => props.theme.fontWeightBold};
  }
`;

interface EmailSentMessageProps {
  email: string;
}

export function EmailSentMessage({ email }: EmailSentMessageProps) {
  const homeRoute = getHomeRoute();

  return (
    <EmailSentMessageWrapper>
      <AuthHeading>The ball is in your court!</AuthHeading>
      <IntroMessage>
        Instructions for resetting your password were sent to <em>{email}</em>.
        You should receive them within a few minutes. your password.
      </IntroMessage>
      <ButtonLink href={homeRoute}>Back to homepage</ButtonLink>
    </EmailSentMessageWrapper>
  );
}
